import React from 'react';
import rem from '../../utils/rem';
import { Icon } from '../icon';
import { Box, Flex, ShadowBox, Text } from '../primitives';

interface IMessageBubble {
  hasArrow?: boolean;
  message: string;
}

export const MessageBubble = ({
  hasArrow = false,
  message,
}: IMessageBubble) => (
  <ShadowBox width={rem(483)} px="large" py="medium" alignSelf="flex-end">
    {hasArrow && (
      <Box
        position="absolute"
        zIndex={1}
        bottom={rem(-8)}
        left={rem(120)}
        width={0}
        height={0}
        borderStyle="solid"
        borderColor="transparent_white"
        borderWidth={rem(8)}
        borderBottomWidth={0}
        borderTopColor="light"
      />
    )}
    <Flex alignItems="center">
      <Icon name="message-bubble-blink" color="accent" size={rem(70)} />
      <Text fontSize={rem(18)} fontWeight={600} ml="large">
        {message}
      </Text>
    </Flex>
  </ShadowBox>
);
